// extracted by mini-css-extract-plugin
module.exports = {"ArticleDownload":"ArticleDownload_ArticleDownload__5ODQ_","Label":"ArticleDownload_Label__3EGwx"};